interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  href: string;
  highlighted?: boolean;
}

export default function ServiceCard({ icon, title, description, href, highlighted = false }: ServiceCardProps) {
  return (
    <a
      href={href}
      className={`group block rounded-lg border transition-all duration-200 cursor-pointer ${
        highlighted
          ? 'bg-primary-500 border-primary-500'
          : 'bg-background-50 border-background-200 hover:border-primary-200'
      }`}
    >
      <div className="p-5 md:p-6">
        <div className={`w-12 h-12 rounded-md flex items-center justify-center mb-4 ${
          highlighted ? 'bg-accent-500/20' : 'bg-primary-50'
        }`}>
          <i className={`${icon} text-xl w-5 h-5 flex items-center justify-center ${
            highlighted ? 'text-accent-400' : 'text-primary-400'
          }`}></i>
        </div>
        <h3 className={`font-heading font-semibold text-base mb-2 ${
          highlighted ? 'text-background-50' : 'text-foreground-800'
        }`}>
          {title}
        </h3>
        <p className={`text-sm leading-relaxed ${
          highlighted ? 'text-primary-100' : 'text-secondary-500'
        }`}>
          {description}
        </p>
        <span className={`inline-flex items-center gap-1 mt-3 text-sm font-medium transition-colors ${
          highlighted ? 'text-accent-400 group-hover:text-accent-300' : 'text-primary-500 group-hover:text-primary-600'
        }`}>
          En savoir plus
          <i className="ri-arrow-right-line text-xs w-3 h-3 flex items-center justify-center"></i>
        </span>
      </div>
    </a>
  );
}